var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrypto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.67,
    height: 17.674,
    viewBox: "0 0 17.67 17.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1075",
    "data-name": "Rectangle 1075",
    width: 17.67,
    height: 17.674,
    fill: "#faa84f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M17.67,8.839A8.835,8.835,0,1,1,8.851,0,8.851,8.851,0,0,1,17.67,8.839m-6.449-.487.092-.053a1.436,1.436,0,0,0,.682-.814,1.959,1.959,0,0,0,.074-.762,1.551,1.551,0,0,0-.921-1.367,4.119,4.119,0,0,0-1.392-.349c-.067-.007-.083-.026-.082-.091,0-.5,0-1,0-1.5,0-.061-.013-.084-.079-.082q-.406.006-.812,0c-.067,0-.087.015-.087.084,0,.487,0,.975,0,1.463,0,.057-.008.079-.073.079q-.313,0-.625.012c-.07,0-.084-.019-.084-.085,0-.49,0-.98,0-1.47,0-.063-.015-.083-.08-.082q-.455.005-.91,0c-.067,0-.086.017-.086.084,0,.5,0,1,0,1.5,0,.077-.023.093-.095.092C6.169,5,5.584,5,5,5c-.077,0-.093.023-.092.095,0,.284,0,.569,0,.853,0,.06.015.078.077.078.219,0,.439-.005.658,0a.48.48,0,0,1,.508.525v4.363a.973.973,0,0,1,0,.106.212.212,0,0,1-.142.19.47.47,0,0,1-.174.032c-.227,0-.455,0-.683,0-.063,0-.082.02-.091.079-.055.344-.112.689-.173,1.032-.013.074,0,.1.079.1.6,0,1.2-.014,1.795.031.068.005.09.022.09.095,0,.49,0,.98,0,1.47,0,.056.014.074.072.073.306,0,.612,0,.918,0,.068,0,.086-.018.085-.085,0-.479,0-.959,0-1.438,0-.066.013-.088.083-.086.2.006.4,0,.593,0,.12,0,.1-.015.105.1,0,.474,0,.948,0,1.422,0,.065.018.081.081.081q.41-.005.821,0c.062,0,.076-.018.076-.078,0-.474,0-.948,0-1.422,0-.132,0-.131.134-.137a5.122,5.122,0,0,0,1.455-.263,1.891,1.891,0,0,0,1.246-1.2,2.915,2.915,0,0,0,.14-1.112,1.509,1.509,0,0,0-.828-1.332,2.564,2.564,0,0,0-.6-.225",
    transform: "translate(0 0)",
    fill: "#faa84f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M18.665,22.567c0-.341,0-.682,0-1.023,0-.051.006-.075.068-.076a11.026,11.026,0,0,1,1.184.017,2.8,2.8,0,0,1,.976.248.911.911,0,0,1,.349,1.368,1.159,1.159,0,0,1-.571.369,3.463,3.463,0,0,1-.945.176c-.33.027-.66.017-.99.017-.057,0-.072-.017-.072-.073,0-.341,0-.682,0-1.023",
    transform: "translate(-10.746 -12.356)",
    fill: "#faa84f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M18.665,15.429q0-.459,0-.918c0-.039-.006-.073.054-.074A6.155,6.155,0,0,1,20,14.5a1.885,1.885,0,0,1,.468.153.874.874,0,0,1,.417,1.138.921.921,0,0,1-.57.476,3.279,3.279,0,0,1-1.069.165c-.171,0-.341,0-.511,0-.06,0-.078-.015-.077-.076,0-.308,0-.617,0-.926",
    transform: "translate(-10.745 -8.309)",
    fill: "#faa84f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrypto);
export default __webpack_public_path__ + "static/media/crypto.c96788ae52f72e97b718d6b2d04911c0.svg";
export { ForwardRef as ReactComponent };